var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMiscHorizontal2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 144,
    viewBox: "0 0 375 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M303.58 134.99C338.374 134.99 366.58 106.786 366.58 71.9951C366.58 37.2039 338.374 9 303.58 9L72.0001 9C37.2061 9 9.00006 37.2039 9.00006 71.9951C9.00006 106.786 37.2061 134.99 72.0001 134.99H303.58Z",
    stroke: "url(#paint0_linear_55_2006)",
    strokeWidth: 16.75,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_55_2006",
    x1: 0.630054,
    y1: 72.0001,
    x2: 374.96,
    y2: 72.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28AD7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#28AD7E",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiscHorizontal2);
export default __webpack_public_path__ + "static/media/miscHorizontal2.4ce7d0a50d489173bbbf853bb02e73da.svg";
export { ForwardRef as ReactComponent };